import { matchRoutes } from "react-router";
import { initializeFaro, createReactRouterV6DataOptions, ReactIntegration, getWebInstrumentations, Faro } from "@grafana/faro-react";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";

export let faro: any = { api: { setUser: () => {} } };

export const initFaro = (isLocal: boolean) => {
  if (isLocal) return faro;

  faro = initializeFaro({
    url: "https://faro-collector-prod-sa-east-1.grafana.net/collect/ce848e10d339fd908d9e818b533aecce",
    app: {
      name: "Softphone Web",
      version: import.meta.env.PACKAGE_VERSION,
      environment: import.meta.env.MODE,
    },

    instrumentations: [
      // Mandatory, omits default instrumentations otherwise.
      ...getWebInstrumentations(),

      // Tracing package to get end-to-end visibility for HTTP requests.
      new TracingInstrumentation(),

      // React integration for React applications.
      new ReactIntegration({
        router: createReactRouterV6DataOptions({
          matchRoutes,
        }),
      }),
    ],
  });

  return faro;
};
